// @flow
import React from 'react'
import styled from 'styled-components'

import {
  variantColorMap,
  VARIANT_DISABLED,
  VARIANT_SECONDARY,
} from '../../constants/variants'
import { theme } from '../../constants/theme'
import { Loader } from '../icons/Loader'
import { Pen } from '../icons/Pen'
import { Eye } from '../icons/Eye'

import { Body } from './Typography'
import { Link } from './Link'
import { Margin } from './Margin'
import { history } from '../../utils/history'

export const Button = ({
  onClick,
  fullWidth,
  variant,
  tradId,
  upper = true,
  bold = true,
  loading = false,
  disabled = false,
  hideIconWhileLoading = true,
  children,
  link = false,
  to,
  relative,
  icon = null,
  ...props
}) => {
  const forwarded = {}
  const finalOnclick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    onClick(e)
  }

  if (!disabled && onClick) {
    forwarded.onClick = finalOnclick
  }
  const button = (
    <CustomButton
      buttonType={disabled ? VARIANT_DISABLED : variant}
      variant={disabled ? VARIANT_DISABLED : variant}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      {...forwarded}
      {...props}
    >
      {children || (
        <>
          <Body tradId={tradId} upper={upper} bold={bold} />
          {tradId && icon && <Margin h={9} />}
          {hideIconWhileLoading && loading ? null : icon}
        </>
      )}
      {loading && (
        <>
          <Margin h={10} />
          <Loader height={14} />
        </>
      )}
    </CustomButton>
  )

  return link ? <Link to={to} relative={relative}>{button}</Link> : button
}

const CustomButton = styled.button`
  border: ${({ variant }) => variantColorMap[variant]} 2px solid;
  border-radius: 5px;
  outline:none;
  background: none;
  ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : '')}
  padding: 15px 28px;
  margin: 5px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ filled, variant }) => (filled ? theme.colors.white : variantColorMap[variant] || theme.colors.black)};
  ${({ filled, variant }) => (filled ? `background-color: ${variantColorMap[variant]};` : '')}
`

export const RawButton = styled(Button)`
  border: none;
  padding: 0;
`

export const LinkButton = styled(Button)`
  border: none;
  color: ${theme.colors.grayDark}
`

export const BackButton = (props) => {
  return (<Button {...props} onClick={history.back()} />)
}
export const BackLinkButton = (props) => {
  return (<LinkButton {...props} onClick={history.back()} />)
}

export const createCustomButton = (hoverBgColor, component) => styled(component)`
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${theme.transition()};
  color: ${theme.colors.iconGray};
  background: ${theme.colors.bodyGray};
  &:hover {
    color: ${theme.colors.white};
    background: ${hoverBgColor};
  }
  margin: 5px;
`
export const BlueButton = createCustomButton(theme.colors.blueCommon, RawButton)
export const OrangeButton = createCustomButton(theme.colors.warningOrange, RawButton)
export const YellowButton = createCustomButton(theme.colors.warningYellow, RawButton)
export const GreenButton = createCustomButton(theme.colors.green, RawButton)
export const DummyButton = createCustomButton('transparent', RawButton)

export const EditButton = (props) => <BlueButton icon={<Pen />} link {...props} />
export const ViewButton = (props) => <BlueButton icon={<Eye />} link {...props} />
export const GoToItemCreate = (props) => (
  <Button
    variant={VARIANT_SECONDARY}
    bold
    link
    upper={false}
    {...props}
  />
)
